<template>
  <div class="event-chart">
    <div class="event-info">
      <div class="event-name">{{eventItem.eventName}}</div>
      <div class="event-date">Event Date: {{eventItem.prefDate}}</div>
      <!--<div class="chart-data-type">{{eventItem.projPart}} participations</div>-->
    </div>
    <EventChart :labels="chartData.labels" :data="chartData.data" :expectedValue="chartData.expectedValue" :startDate="chartData.startDate"
                :endDate="chartData.endDate" :width="254" :height="200"></EventChart>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EventChart from './event-chart';
  import EventBarChart from './event-bar-chart';
  // import moment from 'moment';

  export default {
    name: 'event-chart',
    components: {
      EventChart,
      EventBarChart
    },
    data () {
      return {
        chartData: {
          labels: [],
          data: [],
          expectedValue: 0,
          startDate: '',
          endDate: ''
        },
        chartItemNumber: 0
      }
    },
    props: {
      eventItem: {
        type: Object,
        default: {}
      },
      reportType: {
        type: String,
        default: 'upcoming'
      }
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({
        actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
      }),
      beginDateOfWeek (y, w) {
        let d = (w * 7);
        return new Date(y, 0, d);
      },
      endDateOfWeek (y, w) {
        let d = (w * 7);
        return new Date(y, 0, d);
      }
    },
    mounted () {
      this.actionGetEventReportChart({ eventId: this.eventItem.id, reportType: this.reportType }).then(response => {
        if (response.message === null) {
          // console.log('actionGetEventReportChart:', response);
          let chartData = response.chartData || [];
          this.chartData.expectedValue = response.expectedValue;

          // let startMonth = moment(response.startDate, 'MM/DD/YYYY').format('MMM');
          // let endMonth = moment(response.endDate, 'MM/DD/YYYY').format('MMM');
          chartData.forEach((item, index) => {
            if (index === 0) {
              this.chartData.labels.push('');
              this.chartData.startDate = item.endDate;
            } else if (index === chartData.length - 1) {
              // if (chartData.length < 4) {

              //   this.chartData.labels.push('');
              //   this.chartData.data.push(0);
              //   this.chartData.data.push(0);
              // }
              // let endMonth = moment(this.endDateOfWeek(item.year, item.week)).format('MMM');
              this.chartData.labels.push('');
              this.chartData.endDate = item.endDate;
            } else {
              this.chartData.labels.push('');
            }
            this.chartData.data.push(item.sumToEndDate);
          });
          this.chartData.data.push(null);
          // this.chartData.labels.push('');
          // console.log('actionGetEventReportChart:', this.chartData);
        } else {
          console.log('actionGetEventReportChart error:', response.message);
        }
      });
    }
  };
</script>

<style lang="less" scoped="">
  .event-chart {
    padding: 16px 0 16px 16px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);
    height: 300px;
    width: 270px;
    float: left;
    margin-top: 24px;
    .event-name {
      height: 24px;
      color: #1D1D1D;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .event-date {
      height: 16px;
      color: #1D1D1D;
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.1px;
      line-height: 16px;
    }

    .chart-data-type {
      height: 24px;
      color: #8E8E8E;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 24px;
      text-align: right;
      position: absolute;
      top: 0;
      right: 8px;
    }

    .event-info {
      position: relative;
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// EventChart.vue?5c3b8016